import React from "react"
import Carousel from 'react-material-ui-carousel'
import {CmCollectionType, SosTeaserType} from "../../types";
import C014StageTeaser from "./C014StageTeaser";
import useWindowSize from "../../../utility/useWindowSize";
import useIsHydrated from "../../../utility/useIsHydrated";

export interface Props {
    cmCollection?: CmCollectionType
    singleStageTeaser?: SosTeaserType
}

// react-material-ui-carousel only knows its real height after mounting and measuring the active
// slide's rendered DOM node, so the container starts at 0 height on first paint and only expands
// afterwards - visibly pushing everything below it (including the H1) down. Reserving this
// min-height keeps the layout stable from the first paint; must match the non-hero heights of
// `HeroImage` in C014StageTeaser.tsx (this carousel never passes `hero`, so those are the ones
// that apply here).
const carouselMinHeight = {
    xs: '330px',
    sm: '338px',
    md: '386px',
    lg: '514px',
    xl: '540px'
};

// https://www.npmjs.com/package/react-material-ui-carousel
function C014StageCarousel(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize()
    const isHydrated = useIsHydrated()

    if (props.singleStageTeaser){
        return <C014StageTeaser item={props.singleStageTeaser}/>
    }
    else
    return <>
        {(props.cmCollection && props.cmCollection.items) || props.singleStageTeaser ?
            <Carousel autoPlay={false} navButtonsAlwaysVisible={props.cmCollection
                && props.cmCollection.items !== undefined && props.cmCollection.items!.length > 1}
                      navButtonsAlwaysInvisible={!greaterThanWindowMedium
                          || (props.cmCollection && props.cmCollection.items !== undefined
                              && props.cmCollection.items!.length === 1)
                          || (!props.cmCollection && props.singleStageTeaser !== undefined)}
                      indicators={false} animation={"slide"}
                      sx={{
                          paddingTop: 0,
                          minHeight: carouselMinHeight,
                          // react-material-ui-carousel's slides are all absolutely positioned on top
                          // of each other, and their opacity/display/x-position is only applied by a
                          // framer-motion layout effect. The server-rendered HTML therefore carries
                          // no visibility styles at all and paints every slide stacked on top of each
                          // other until React hydrates - so the last slide covers the active one. The
                          // active slide is always first in DOM order on the initial render, so
                          // hiding the rest bridges that gap. Dropped again once hydration is done,
                          // because from then on framer-motion owns slide visibility and this rule
                          // would keep every slide except the first permanently invisible (it sits on
                          // the library's slide wrapper, while framer-motion writes its inline styles
                          // on a descendant, so it cannot be overridden from there).
                          ...(!isHydrated ? {
                              '> div:first-of-type > div:not(:first-of-type)': {
                                  opacity: 0
                              }
                          } : {})
                      }}
            >

                {(props.cmCollection !== undefined ?
                    (props.cmCollection.items ?? []) : [props.singleStageTeaser])
                    .map(i => i as SosTeaserType)
                    .filter(i => i.picture)
                    .map((item: SosTeaserType, index: number) =>
                      <C014StageTeaser key={index} item={item}/>

                    )
                }
            </Carousel>
            : null}

    </>
}

export default C014StageCarousel